function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNodata = function SvgIconNodata(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dkocimjgua"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 514",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(-.461 -.461)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 14116"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 14064",
    transform: "translate(.462 .462)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 513",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(-.461 -.461)",
    style: {
      fill: "#ffe76d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 14072"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 14071",
    style: {
      clipPath: "url(#dkocimjgua)"
    },
    transform: "translate(.462 .462)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 14115"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37382",
    d: "M398.345 685.767c-3.361-8.378-9.965-10.584-9.965-10.584v-.007a29.731 29.731 0 0 0-.565-17.5c-5.28-15.866-21.841-15.569-21.841-15.569h-1.534s-16.56-.3-21.841 15.569a29.731 29.731 0 0 0-.565 17.5v.007s-6.6 2.206-9.965 10.584c0 0-3.88 9.892 4.8 12.91l-1.28.433.8 1.3-.867.818a5.339 5.339 0 0 0 5.222.678s2.339-.5 2.305-4.014a77.5 77.5 0 0 0 3.663 17.894 18.143 18.143 0 0 0-5.4 5.432s-.84.892.76.892H360s.68.162.24-1.419c0 0-.5-3.18 1.386-8.714a3.242 3.242 0 0 1 3-1.926h1.155a3.242 3.242 0 0 1 3 1.926c1.89 5.534 1.386 8.714 1.386 8.714-.44 1.582.24 1.419.24 1.419h17.921c1.6 0 .76-.892.76-.892a18.142 18.142 0 0 0-5.4-5.432 77.5 77.5 0 0 0 3.663-17.894c-.034 3.512 2.3 4.014 2.3 4.014a5.34 5.34 0 0 0 5.223-.678l-.867-.818.8-1.3-1.28-.433c8.698-3.018 4.818-12.91 4.818-12.91zm-57.979 5.675a2.689 2.689 0 0 0 2.545-.4 44.319 44.319 0 0 0 .044 5.356 7.672 7.672 0 0 0-2.589-4.956zm47.1 4.959a44.322 44.322 0 0 0 .044-5.356 2.687 2.687 0 0 0 2.544.4 7.674 7.674 0 0 0-2.591 4.955z",
    transform: "translate(-326.669 -626.572)",
    style: {
      stroke: "#1a1311",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37383",
    d: "M363.1 654.434a8.808 8.808 0 0 0 6.285.108 3.585 3.585 0 0 1-.877.948.771.771 0 0 0 .2 1.363 3.986 3.986 0 0 0 1.137.138c1.547 0 4.523-.627 8.043-4.535a.774.774 0 0 0-.049-1.082.749.749 0 0 0-1.067.049c-2.585 2.87-4.769 3.735-6.125 3.962a10.84 10.84 0 0 0 1.216-2.531.769.769 0 0 0-.3-.865.749.749 0 0 0-.9.042 6.569 6.569 0 0 1-5.077 1.467 6.047 6.047 0 0 0 2.193-3.132.756.756 0 1 0-1.465-.376A4.549 4.549 0 0 1 363.2 653a.769.769 0 0 0-.092 1.436z",
    transform: "translate(-331.747 -627.669)",
    style: {
      fill: "#1a1311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37384",
    d: "M374.9 669.127a.752.752 0 0 0-.746-.756h-6.082a.755.755 0 0 0-.592 1.212l3 4.607a.738.738 0 0 0 1.248 0l3.038-4.637a.76.76 0 0 0 .134-.426z",
    transform: "translate(-332.502 -630.515)",
    style: {
      fill: "#1a1311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37385",
    d: "M363.3 665.07a2.736 2.736 0 0 0-.579-2.005 2.67 2.67 0 0 0-1.809-1 2.709 2.709 0 0 0-2.97 2.42 2.726 2.726 0 0 0 2.388 3.01 2.66 2.66 0 0 0 1.98-.587 2.721 2.721 0 0 0 .99-1.838z",
    transform: "translate(-330.983 -629.565)",
    style: {
      fill: "#1a1311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37386",
    d: "M383.958 663.065a2.67 2.67 0 0 0-1.809-1 2.708 2.708 0 0 0-2.97 2.42 2.726 2.726 0 0 0 2.388 3.01 2.66 2.66 0 0 0 1.98-.587 2.756 2.756 0 0 0 .411-3.84z",
    transform: "translate(-334.413 -629.565)",
    style: {
      fill: "#1a1311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37387",
    d: "M394.8 667.437a3.5 3.5 0 0 1-7 0c0-1.843 3.5-6.664 3.5-6.664s3.5 4.822 3.5 6.664z",
    transform: "translate(-336.258 -634.233)",
    style: {
      fill: "#85c3ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 11928",
    transform: "translate(10.539 61.539)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h55v16H0z"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNodata, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_nodata.853f09ab.svg";
export { ForwardRef as ReactComponent };